import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/startOfMonth/index.js';

var require$$42 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$42 as default };
